import React from 'react';
import { GroupDimension, StatusFilter } from '../types';
import './FilterBar.scss';

interface FilterBarProps {
  groupDimension: GroupDimension;
  onGroupDimensionChange: (dimension: GroupDimension) => void;
  sourcingOptions: string[];
  sourcingFilter: string;
  onSourcingFilterChange: (value: string) => void;
  statusFilters: Set<StatusFilter>;
  onToggleStatusFilter: (filter: StatusFilter) => void;
  inTransitOnly: boolean;
  onToggleInTransitOnly: () => void;
}

const STATUS_FILTER_CONFIG: { key: StatusFilter; label: string }[] = [
  { key: 'overdue', label: 'Overdue' },
  { key: 'noplan', label: 'Schedule missing' },
  { key: 'today', label: 'Today scheduled' },
  { key: 'onhold', label: 'On hold' },
];

export const FilterBar: React.FC<FilterBarProps> = ({
  groupDimension,
  onGroupDimensionChange,
  sourcingOptions,
  sourcingFilter,
  onSourcingFilterChange,
  statusFilters,
  onToggleStatusFilter,
  inTransitOnly,
  onToggleInTransitOnly,
}) => (
  <div className="filter-bar">
    <div className="filter-bar__seg">
      <button
        type="button"
        className={`filter-bar__opt ${groupDimension === 'vendor' ? 'is-active' : ''}`}
        onClick={() => onGroupDimensionChange('vendor')}
      >
        By vendor
      </button>
      <button
        type="button"
        className={`filter-bar__opt ${groupDimension === 'client' ? 'is-active' : ''}`}
        onClick={() => onGroupDimensionChange('client')}
      >
        By client
      </button>
    </div>

    <select
      className="filter-bar__select"
      value={sourcingFilter}
      onChange={(e) => onSourcingFilterChange(e.target.value)}
    >
      <option value="">All owners</option>
      {sourcingOptions.map((owner) => (
        <option key={owner} value={owner}>
          {owner}
        </option>
      ))}
    </select>

    <div className="filter-bar__spacer" />

    <div className="filter-bar__chip-group">
      {STATUS_FILTER_CONFIG.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          className={`filter-bar__chip filter-bar__chip--${key} ${statusFilters.has(key) ? 'is-active' : ''}`}
          onClick={() => onToggleStatusFilter(key)}
        >
          {label}
        </button>
      ))}

      <button
        type="button"
        className={`filter-bar__chip filter-bar__chip--intransit ${inTransitOnly ? 'is-active' : ''}`}
        onClick={onToggleInTransitOnly}
      >
        🚚 In transit
      </button>
    </div>
  </div>
);
